import axios from "."

export default {
  createSession,
  getPendingSession
}

async function createSession(data) {
  const response = await axios.post("face2face-calling/session-create", data)
  return response.data
}

async function getPendingSession(data) {
  const response = await axios.get("face2face-calling/call-requests")
  return response?.data?.result
}
